export type VisitorEntryPolicy = {
  pin_access_enabled?: boolean;
  guest_pin_access_enabled?: boolean;
  delivery_access_enabled?: boolean;
  face_access_enabled?: boolean;
};

export type IntercomEntryPolicy = {
  pin_access_enabled?: boolean | null;
  guest_pin_access_enabled?: boolean | null;
  face_access_enabled?: boolean | null;
};

export function showVisitorPinEntry(property: VisitorEntryPolicy | null, intercom: IntercomEntryPolicy): boolean {
  // Intercom settings are authoritative. Property delivery policy is the only
  // property-wide capability that can require the shared keypad.
  if (intercom.pin_access_enabled === true) return true;
  if (intercom.pin_access_enabled === false) return false;
  if (intercom.guest_pin_access_enabled === true) return true;
  if (intercom.guest_pin_access_enabled === false && property?.pin_access_enabled !== true && property?.delivery_access_enabled !== true) return false;
  return property?.pin_access_enabled === true || property?.guest_pin_access_enabled === true || property?.delivery_access_enabled === true;
}

export function showVisitorFaceEntry(property: VisitorEntryPolicy | null, intercom: IntercomEntryPolicy): boolean {
  if (typeof intercom.face_access_enabled === 'boolean') return intercom.face_access_enabled;
  return property?.face_access_enabled === true;
}
